// Module
var code = "<md-button class=\"abm-back-nav md-icon-button\" aria-label=\"Back\" abm-back-nav nav-back=\"navBack\" nav-default=\"navDefault\"> <md-icon class=\"material-icons\">arrow_back</md-icon> </md-button> ";
// Exports
module.exports = code;